export default {
    root: {
        zIndex: '1',
        '&$expanded': {
            margin: '1px 0',
        },
    },
};
